import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const PricePlanRevisionsState = (state: RootState) => state.supportAtHome.pricePlanRevisions;

export const selectPricePlanRevisions = (state: RootState) => PricePlanRevisionsState(state).rows;
export const selectPricePlanRevision = (state: RootState) => PricePlanRevisionsState(state).row;
export const selectPricePlanRevisionsLoading = (state: RootState) => PricePlanRevisionsState(state).loading;
export const selectErrorResponse = (state: RootState) => PricePlanRevisionsState(state).error;

export const selectPricePlanRevisionOptions = createSelector(selectPricePlanRevisions, (rows) =>
  [...rows].sort((a, b) => b.sequence - a.sequence).map(({ id, sequence }) => ({ id, value: id, label: sequence })),
);
